import {QuicksightDashboard} from "../../../services/QuicksightService";

export const getQuicksightUsersDashboardsQueryKey = (
  emails: ReadonlyArray<string>,
) =>
  [
    "quicksightUsersDashboards",
    ...[...emails].map(email => email.toLowerCase()).sort(),
  ] as const;

export const dashboardsByEmailFromUsers = (
  emails: ReadonlyArray<string>,
  users: ReadonlyArray<{
    email?: string;
    dashboards?: ReadonlyArray<QuicksightDashboard>;
  }> = [],
): Readonly<Record<string, ReadonlyArray<QuicksightDashboard>>> => {
  const byNormalizedEmail = new Map<
    string,
    ReadonlyArray<QuicksightDashboard>
  >();

  users.forEach(user => {
    if (!user.email) {
      return;
    }

    byNormalizedEmail.set(
      user.email.toLowerCase(),
      (user.dashboards ?? []).map(dashboard => ({
        id: dashboard.id,
        name: dashboard.name,
      })),
    );
  });

  return Object.fromEntries(
    emails.map(email => [
      email,
      byNormalizedEmail.get(email.toLowerCase()) ?? [],
    ]),
  );
};
